<!-- ll-standards-ignore LL008 -- presentational only; its logic is one ternary, asserted
     through ApproveAgentDialog.spec.ts which renders it. -->
<template>
  <div class="bg-grey-lighten-4 rounded p-3" data-cy="agent-identity">
    <div class="font-weight-medium">{{ agent.name }}</div>
    <div class="text-caption text-grey-darken-1 mt-1">{{ agent.origin }}</div>
    <div class="mt-2">
      <LlStatusBadge :tone="agent.isVerifiedPublisher ? 'green' : 'amber'">
        {{ agent.isVerifiedPublisher ? 'Verified publisher' : 'Publisher not verified' }}
      </LlStatusBadge>
    </div>
    <p v-if="!agent.isVerifiedPublisher" class="text-caption text-amber-darken-4 mt-2 mb-0">
      LeanLaw has not verified this publisher. Check the address is one you recognise before approving.
    </p>
  </div>
</template>

<script setup lang="ts">
import LlStatusBadge from '@/components/LlStatusBadge.vue';
import type { AgentAccessAgent } from '../models/agentAccessTypes';

// The address is shown alongside the name everywhere an agent is named, never replaced by it: the
// name is whatever a publisher chose to call itself, the address is what cannot be faked.
defineProps<{ agent: AgentAccessAgent }>();
</script>
